import { render, staticRenderFns } from "./media_por_trimestre.vue?vue&type=template&id=10adadd5&scoped=true&"
import script from "./media_por_trimestre.vue?vue&type=script&lang=js&"
export * from "./media_por_trimestre.vue?vue&type=script&lang=js&"
import style0 from "./media_por_trimestre.vue?vue&type=style&index=0&id=10adadd5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10adadd5",
  null
  
)

export default component.exports